import ScrollCarousel, { measureSlidesPerView } from '../ScrollCarousel';

const SELECTORS = {
  viewport: '[data-recent-articles-carousel-viewport]',
  track: '[data-recent-articles-carousel-track]',
};

const carousels = [];

export default () => {
  const carouselElements = document.querySelectorAll('[data-recent-articles-carousel]');

  if (carouselElements.length === 0) {
    return;
  }

  carouselElements.forEach((el) => {
    const viewport = el.querySelector(SELECTORS.viewport);
    const track = el.querySelector(SELECTORS.track);
    if (!viewport || !track || track.children.length === 0) {
      return;
    }

    const slides_per_view = measureSlidesPerView(viewport, track.children[0]);

    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      // `contain: true` is handled in SCSS. `cellAlign: 'center'` has no
      // scroll-snap equivalent that keeps grouping intact, so slides snap to
      // `start` — the same accepted limitation as the pods carousels
      // (WIN-8070 Risk #10).
      loop: false,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: slides_per_view,
      // Flickity `groupCells: true`.
      slidesPerGroup: slides_per_view,
      ariaLabel: 'Recent articles carousel',
    });

    carousels.push(carousel);

    // A single dot means nothing to navigate to. ScrollCarousel only builds the
    // dots element when there is more than one, so this replaces the old
    // post-hoc hide — which read Flickity's `.dot`/`.flickity-page-dots` and
    // dereferenced a null element whenever no dots had been rendered.
    triggerResize();
  });
};

function triggerResize() {
  const event = new Event('resize');
  window.dispatchEvent(event);
}
